import { render, staticRenderFns } from "./Ebooks.vue?vue&type=template&id=7fc8d4b0&scoped=true&"
import script from "./Ebooks.vue?vue&type=script&lang=js&"
export * from "./Ebooks.vue?vue&type=script&lang=js&"
import style0 from "./Ebooks.vue?vue&type=style&index=0&id=7fc8d4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc8d4b0",
  null
  
)

export default component.exports